import { ONE_MEGABYTE, RequiredFileUploaderOptions } from '../file-uploader-types';
import {
    FILE_ERROR,
    FILE_IS_TOO_LARGE,
    FILE_IS_TOO_SMALL,
    FILE_TYPE_NOT_ALLOWED,
    HAVE_ALREADY_CHOOSEN_FILE,
    TOTAL_FILE_SIZE_TOO_LARGE,
    Warnings,
} from './warning-types';

const fileOrFilesError = (filnavn: string[]) => {
    return filnavn.length > 1
        ? `Kunne ikke laste opp filene: ${filnavn.join(', ')}.`
        : `Kunne ikke laste opp fil: ${filnavn.join(', ')}.`;
};

const defaultWarnings = ({
    maxFileByteSize,
    maxCombinedUploadByteSize,
    largeFormatFileTypes,
    fileErrorText,
}: RequiredFileUploaderOptions): Warnings => {
    const maxFileSizeMegaBytes = maxFileByteSize / ONE_MEGABYTE;
    const maxCombinedUploadMegaBytes = maxCombinedUploadByteSize / ONE_MEGABYTE;
    return {
        [HAVE_ALREADY_CHOOSEN_FILE]: {
            fileName: [],
            warningText: (fileName) =>
                fileName.length > 1
                    ? `Du har lastet opp disse filene fra før: ${fileName.join(', ')}.`
                    : `Du har lastet opp ${fileName.join(', ')} fra før.`,
        },
        [FILE_IS_TOO_LARGE]: {
            fileName: [],
            warningText: (fileName) =>
                fileName.length > 1
                    ? `Filene ${fileName.join(', ')} er for store. Maks filstørrelse er ${maxFileSizeMegaBytes} MB.`
                    : `Filen ${fileName.join(', ')} er for stor. Maks filstørrelse er ${maxFileSizeMegaBytes} MB.`,
        },
        [FILE_IS_TOO_SMALL]: {
            fileName: [],
            warningText: (fileName) =>
                fileName.length > 1
                    ? `Filene ${fileName.join(', ')} er for små. 
                    Minimum filstørrelse er 1 kb for typene ${largeFormatFileTypes?.join(', ')} og 1 byte for andre.`
                    : `Filen ${fileName.join(', ')} er for liten. 
                    Minimum filstørrelse er 1 kb for typene ${largeFormatFileTypes?.join(', ')} og 1 byte for andre.`,
        },
        [FILE_TYPE_NOT_ALLOWED]: {
            fileName: [],
            warningText: (fileName) =>
                fileName.length > 1
                    ? `Støtter ikke filtypene til følgende filer: ${fileName.join(', ')}.`
                    : `Støtter ikke filtypen til ${fileName.join(', ')}.`,
        },
        [TOTAL_FILE_SIZE_TOO_LARGE]: {
            fileName: [],
            warningText: (fileName) =>
                `Kunne ikke laste opp filene: ${fileName.join(
                    ', ',
                )}. \n\nTotal filstørrelse overstiger grensen på ${maxCombinedUploadMegaBytes} MB.`,
        },
        [FILE_ERROR]: {
            fileName: [],
            warningText: (fileName) => `${fileOrFilesError(fileName)} ${fileErrorText || ''}`,
        },
    };
};

export default defaultWarnings;
